import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import styles from './index.module.scss'

export const TC_STATUS_CONFIG = {
  signed: { label: 'SIGNED', className: 'statusSigned', iconClassName: 'iconSigned' },
  unsigned: { label: 'UNSIGNED', className: 'statusUnsigned', iconClassName: 'iconUnsigned' },
  expired: { label: 'LINK EXPIRED', className: 'statusExpired', iconClassName: 'iconExpired' },
  unsent: { label: 'UNSENT', className: 'statusUnsent', iconClassName: 'iconUnsent' }
}

// Accepts raw enums or human readable strings from the API and maps them onto TC_STATUS_CONFIG keys.
const STATUS_ALIASES = {
  signed: 'signed',
  unsigned: 'unsigned',
  pending: 'unsigned',
  pending_signature: 'unsigned',
  awaiting_signature: 'unsigned',
  sent: 'unsigned',
  expired: 'expired',
  link_expired: 'expired',
  unsent: 'unsent',
  not_sent: 'unsent'
}

export function normalizeTcStatus (status) {
  if (!status) return null
  const key = String(status).trim().toLowerCase().replace(/[\s-]+/g, '_')
  return STATUS_ALIASES[key] || null
}

export function getAgreementStatusDisplay (status) {
  const config = TC_STATUS_CONFIG[normalizeTcStatus(status)]
  if (!config) return null

  return {
    label: config.label.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()),
    iconClass: styles[config.iconClassName]
  }
}

export default function TCStatusBadge ({ status }) {
  const config = TC_STATUS_CONFIG[normalizeTcStatus(status)]

  if (!config) {
    return <span className={styles.statusUnknown}>—</span>
  }

  return (
    <span className={cn(styles.statusBadge, styles[config.className])}>
      {config.label}
    </span>
  )
}

TCStatusBadge.propTypes = {
  status: PropTypes.string
}
